<template>
  <section class="hero">
    <img
      v-if="image"
      class="hero__image"
      :src="image.url"
      :alt="image.alt"
    >
    <Logo :class="`hero__logo  color--${text_color ? text_color.value : 'dark'}`" v-if="show_logo" />
    <div
      v-else
      :class="`hero__background background--${text_color ? text_color.value : 'dark'}`"
    />

    <heading
      v-if="title"
      :title="title"
      level="h1"

      :class="`hero__heading color--${text_color ? text_color.value : 'dark'} ${text_higher ? 'hero__heading_higher' : ''}`"
    />
  </section>
</template>

<script>
import Logo from '@/icons/Logo'
import Heading from '@/components/heading/Heading'

export default {
  name: 'SectionHeader',
  components: {
    Heading,
    Logo
  },
  props: {
    image: {
      type: Object,
      default: () => {}
    },
    show_logo: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    title_2: {
      type: [String, Boolean],
      default: false
    },
    text_higher: {
      type: Boolean,
      default: false
    },
    text_color: {
      type: Object,
      default: () => {
        'dark'
      }
    }
  }
}
</script>

<docs>
  ```vue
    <section-header
      title="title"
      :image="{
        id: 'images::hotel/welcome.png',
        url: 'https://picsum.photos/seed/picsum/200/300',
        permalink: 'http://hotel-api.test/storage/hotel/welcome.png',
        api_url: 'http://hotel-api.test/content-api/assets/images/hotel/welcome.png',
        width: 375,
        height: 320,
        alt: 'Alt text'
      }"
    />
  ```
  ```scss
  // Variable defaults:
  $hero-height: rem(320);
  $hero-image-opacity: 0.5;
  $hero-heading-padding: $padding;
  $hero-heading-bottom: rem(70);
  ```
</docs>


<style lang="scss">
.hero {
  position: relative;
  height: $hero-height;
  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: $hero-image-opacity;
  }
  &__logo {
    position: absolute;
    top: $padding;
    left: $padding;
    width: 20%;
  }
  &__heading {
    position: absolute;
    //bottom: $hero-heading-bottom;
    bottom: 1.375rem; // 4.375rem; with overlap
    padding: $hero-heading-padding;
    font-family: Didot, serif;
  }
  &__heading_higher {
    bottom: 4.375rem; // 4.375rem; with overlap
  }
}
</style>
